import {Component, OnInit, OnDestroy, Output, EventEmitter, SimpleChanges, OnChanges, Input} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import {UserService} from '@services/user.service';
import {AuthService} from '@services/auth.service';
import {FontAwesomeService} from '@services/font-awesome.service';
import {ShipmentService} from '@services/shipment.service';
import {InitInformation} from '@models/init-information.interface';
import {AppState, selectUserData} from "@store/reducers";
import {Store} from "@ngrx/store";

@Component({
  selector: 'app-company-information',
  templateUrl: './company-information.component.html',
  styleUrls: ['./company-information.component.scss']
})
export class CompanyInformationComponent implements OnInit, OnDestroy {

  completed = true;
  company: string;
  addressData: any;
  possibleCountries: Array<{value: string; label: string}>;
  @Input() submitted: boolean;
  @Input('userDetails') userDetails: any;
  @Input('errors') errors: any;
  @Input() form: FormGroup;
  @Output() changeCompany: EventEmitter<any> = new EventEmitter();
  private destroy$: Subject<boolean> = new Subject();
  constructor(
    private _fb: FormBuilder,
    private auth: AuthService,
    private userService: UserService,
    public faService: FontAwesomeService,
    private shipmentService: ShipmentService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    if (!this.possibleCountries) {
      this.shipmentService.getInitialData()
        .subscribe((data: InitInformation) => {
          this.possibleCountries = this.shipmentService.possibleCountries;
        });
    }

    this.store.select(selectUserData)
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.addressData = value;
      });
  }

  copyAddress() {
    const formData = this.form.getRawValue();
    const disabled = formData.same_as_invoice_address;
    this.form.get('address')
      .setValue((disabled ? formData.invoice_address : this.addressData.address) || '');
    this.form.get('zip').reset((disabled ? formData.invoice_zip : this.addressData.zip) || '');
    this.form.get('city')
      .reset((disabled ? formData.invoice_city : this.addressData.city) || '');
    this.form.get('country_code').setValue(
      `${disabled ? formData.invoice_country_code : (this.addressData.country_code || 'SE')}`,
      {emitEvent: false}
      );
    if (disabled) {
      this.form.get('address').disable();
      this.form.get('city').disable();
      this.form.get('zip').disable();
      this.form.get('country_code').disable({emitEvent: false});
    } else {
      this.form.get('address').enable();
      this.form.get('city').enable();
      this.form.get('zip').enable();
      this.form.get('country_code').enable({emitEvent: false});
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/user-settings/company-information/company-information.component.ts